export const TOOLKITS = [
  { slug: "bgjcpt", title: "Black Girl Joy Challenge", live: true, color: "#AD1C5D" },
  { slug: "dream-fund", title: "Black Girls Dream Fund", live: false, color: "#400057" },
  { slug: "climate-fund", title: "Environment & Climate Fund", live: false, color: "#67DAD7" },
  { slug: "dream-investment", title: "Dream Investment Program", live: false, color: "#E02189" },
];

export const toolkitTitle = (slug) => TOOLKITS.find((t) => t.slug === slug)?.title || slug;
